import { lazy } from 'react';

const SalesList = lazy(() => import('./list'));

export { SalesList };
